export const RESUMEAD_KEY = '__ra';
export const POSTDATA_KEY = '__pa';

export const SOURCE =
  __ANALYTICS_DOMAIN_CLIENT__ === 'CF' // eslint-disable-line
    ? 'CF'
    : __ANALYTICS_DOMAIN_CLIENT__ === 'Quikr' // eslint-disable-line
      ? 'QH'
      : 'OTHER';

export const DEFAULT_COORDINATES = {
  LAT: 20.5937,
  LON: 78.9629
};

export const SALE_TYPES = [
  {
    label: 'Resale',
    value: 'RESALE'
  },
  {
    label: 'New',
    value: 'NEW'
  }
];

export const CATEGORIES = {};
CATEGORIES.CF = false;
CATEGORIES.QH = [
  {
    label: 'Residential',
    value: 'RESIDENTIAL'
  },
  {
    label: 'Commercial',
    value: 'COMMERCIAL'
  },
  {
    label: 'Agricultural',
    value: 'AGRICULTURE'
  }
];

export const INTENT = {};
INTENT.CF = [
  {
    label: 'Sell',
    value: 'SELL'
  },
  {
    label: 'Rent',
    value: 'RENT'
  }
];
INTENT.QH = {
  RESIDENTIAL: [
    {
      label: 'Sell',
      value: 'SELL'
    },
    {
      label: 'Rent',
      value: 'RENT'
    },
    {
      label: 'PG',
      value: 'PG'
    },
    {
      label: 'Flatmate',
      value: 'FLATMATE'
    }
  ],
  COMMERCIAL: [
    {
      label: 'Sell',
      value: 'SELL'
    },
    {
      label: 'Rent',
      value: 'RENT'
    }
  ],
  AGRICULTURE: [
    {
      label: 'Sell',
      value: 'SELL'
    }
  ]
};

export const PROPERTY_TYPES = {};
PROPERTY_TYPES.CF = {
  SELL: [
    {
      label: 'Apartment',
      value: 'APARTMENT'
    },
    {
      label: 'Builder Floor',
      value: 'BUILDER_FLOOR'
    },
    {
      label: 'Plot',
      value: 'PLOT'
    },
    {
      label: 'House/Villa',
      value: 'HOUSE_VILLA'
    }
  ],
  RENT: [
    {
      label: 'Apartment',
      value: 'APARTMENT'
    },
    {
      label: 'Builder Floor',
      value: 'BUILDER_FLOOR'
    },
    {
      label: 'House/Villa',
      value: 'HOUSE_VILLA'
    }
  ]
};
PROPERTY_TYPES.QH = {
  RESIDENTIAL: {
    SELL: [
      {
        label: 'Apartment',
        value: 'APARTMENT'
      },
      {
        label: 'Villa',
        value: 'HOUSE_VILLA'
      },
      {
        label: 'Builder Floor',
        value: 'BUILDER_FLOOR'
      },
      {
        label: 'Plot',
        value: 'PLOT'
      },
      {
        label: 'Studio Apartment',
        value: 'STUDIO_APARTMENT'
      },
      {
        label: 'Farm House',
        value: 'FARM_HOUSE'
      }
    ],
    RENT: [
      {
        label: 'Apartment',
        value: 'APARTMENT'
      },
      {
        label: 'Villa',
        value: 'HOUSE_VILLA'
      },
      {
        label: 'Builder Floor',
        value: 'BUILDER_FLOOR'
      },
      {
        label: 'Studio Apartment',
        value: 'STUDIO_APARTMENT'
      },
      {
        label: 'Farm House',
        value: 'FARM_HOUSE'
      },
      {
        label: 'Service Apartment',
        value: 'SERVICE_APARTMENT'
      }
    ],
    PG: [
      {
        label: 'Apartment',
        value: 'APARTMENT'
      },
      {
        label: 'Villa',
        value: 'HOUSE_VILLA'
      },
      {
        label: 'Builder Floor',
        value: 'BUILDER_FLOOR'
      }
    ],
    FLATMATE: [
      {
        label: 'Apartment',
        value: 'APARTMENT'
      },
      {
        label: 'Villa',
        value: 'HOUSE_VILLA'
      },
      {
        label: 'Builder Floor',
        value: 'BUILDER_FLOOR'
      }
    ]
  },
  COMMERCIAL: {
    SELL: [
      {
        label: 'Office',
        value: 'OFFICE'
      },
      {
        label: 'Shop',
        value: 'SHOP'
      },
      {
        label: 'Complex',
        value: 'COMPLEX'
      },
      {
        label: 'Plot',
        value: 'PLOT'
      }
    ],
    RENT: [
      {
        label: 'Office',
        value: 'OFFICE'
      },
      {
        label: 'Shop',
        value: 'SHOP'
      },
      {
        label: 'Complex',
        value: 'COMPLEX'
      }
    ]
  },
  AGRICULTURE: {
    SELL: [
      {
        label: 'Land',
        value: 'LAND'
      }
    ]
  }
};

export const ACCOMMODATION = {
  CF: false,
  QH: {
    RESIDENTIAL: {
      RENT: [
        {
          label: 'Family',
          value: 'FAMILY'
        },
        {
          label: 'Single Men',
          value: 'SINGLE_MEN'
        },
        {
          label: 'Single Women',
          value: 'SINGLE_WOMEN'
        },
        {
          label: 'No Preference',
          value: 'NO_PREFERENCE'
        }
      ],
      PG: [
        {
          label: 'Male',
          value: 'MALE'
        },
        {
          label: 'Female',
          value: 'FEMALE'
        }
      ],
      FLATMATE: [
        {
          label: 'Male',
          value: 'MALE'
        },
        {
          label: 'Female',
          value: 'FEMALE'
        }
      ]
    }
  }
};

export const OCCUPANCY = {
  CF: false,
  QH: [
    {
      label: 'Single',
      value: 'SINGLE'
    },
    {
      label: 'Sharing',
      value: 'SHARING'
    },
    {
      label: 'Both',
      value: 'BOTH'
    }
  ]
};

export const GLOBAL_IDS = {
  CF: {
    SELL: {
      PLOT: 217,
      HOUSE_VILLA: 271,
      APARTMENT: 31,
      BUILDER_FLOOR: 287
    },
    RENT: {
      HOUSE_VILLA: 270,
      APARTMENT: 32,
      BUILDER_FLOOR: 288
    }
  },
  QH: {
    SELL: {
      'APARTMENT,BUILDER_FLOOR,STUDIO_APARTMENT,SERVICE_APARTMENT': 31,
      'HOUSE_VILLA,FARM_HOUSE': 271,
      'OFFICE,SHOP,COMPLEX': 33,
      'PLOT,LAND': 217
    },
    RENT: {
      'APARTMENT,BUILDER_FLOOR,STUDIO_APARTMENT,SERVICE_APARTMENT': 32,
      'HOUSE_VILLA,FARM_HOUSE': 270,
      'OFFICE,SHOP,COMPLEX': 215
    },
    PG: {
      'APARTMENT,BUILDER_FLOOR,HOUSE_VILLA': 114
    },
    FLATMATE: {
      'APARTMENT,BUILDER_FLOOR,HOUSE_VILLA': 138
    }
  }
};

export const BATHROOMS = [
  {
    label: '1',
    value: '1'
  },
  {
    label: '2',
    value: '2'
  },
  {
    label: '3',
    value: '3'
  },
  {
    label: '4',
    value: '4'
  },
  {
    label: '4+',
    value: '5'
  }
];

export const USER_TYPE = [
  {
    label: 'Owner',
    value: 'INDIVIDUAL'
  },
  {
    label: 'Agent',
    value: 'BROKER'
  },
  {
    label: 'Builder',
    value: 'BUILDER'
  }
];

export const BROKERAGE_SELL_TYPE = [
  {
    label: 'No Brokerage',
    value: 'NO'
  },
  {
    label: 'Fixed',
    value: 'AMOUNT'
  },
  {
    label: 'Percentage',
    value: 'PERCENTAGE'
  }
];

export const BROKERAGE_RENT_TYPE = [
  {
    label: 'No Brokerage',
    value: 'NO'
  },
  {
    label: 'Fixed',
    value: 'AMOUNT'
  },
  {
    label: 'Based on Rent',
    value: 'BASED_ON_RENT'
  }
];

export const FURNISHING = [
  {
    label: 'Unfurnished',
    value: 'NOT'
  },
  {
    label: 'Semi Furnished',
    value: 'SEMI'
  },
  {
    label: 'Fully Furnished',
    value: 'FULLY'
  }
];

export const UNIT_TYPES = [
  {
    label: '1 RK',
    value: 'ONE_RK'
  },
  {
    label: '1 BHK',
    value: 'ONE_BHK'
  },
  {
    label: '2 BHK',
    value: 'TWO_BHK'
  },
  {
    label: '3 BHK',
    value: 'THREE_BHK'
  },
  {
    label: '4+ BHK',
    value: 'FOUR_BHK'
  }
];

export const BALCONIES = [
  {
    label: '0',
    value: '0'
  },
  {
    label: '1',
    value: '1'
  },
  {
    label: '2',
    value: '2'
  },
  {
    label: '3',
    value: '3'
  },
  {
    label: '4',
    value: '4'
  },
  {
    label: '4+',
    value: '5'
  }
];

export const FACING = [
  {
    label: 'North',
    value: 'NORTH'
  },
  {
    label: 'South',
    value: 'SOUTH'
  },
  {
    label: 'East',
    value: 'EAST'
  },
  {
    label: 'West',
    value: 'WEST'
  },
  {
    label: 'North East',
    value: 'NORTH_EAST'
  },
  {
    label: 'North West',
    value: 'NORTH_WEST'
  },
  {
    label: 'South East',
    value: 'SOUTH_EAST'
  },
  {
    label: 'South West',
    value: 'SOUTH_WEST'
  }
];

export const PARKING = [
  {
    label: '4 Wheeler',
    value: '4W'
  },
  {
    label: '2 Wheeler',
    value: '2W'
  },
  {
    label: 'Both',
    value: 'Both'
  },
  {
    label: 'None',
    value: 'None'
  }
];

export const POPULAR_CITIES = {
  CF: [
    {
      id: '70',
      name: 'Bangalore'
    },
    {
      id: '112',
      name: 'Mumbai'
    },
    {
      id: '36',
      name: 'Delhi'
    },
    {
      id: '118',
      name: 'Pune'
    },
    {
      id: '149',
      name: 'Chennai'
    },
    {
      id: '5',
      name: 'Hyderabad'
    },
    {
      id: '203',
      name: 'Kolkata'
    },
    {
      id: '353',
      name: 'Ahmedabad'
    }
  ],
  QH: [
    {
      id: '23',
      name: 'Bangalore'
    },
    {
      id: '31',
      name: 'Mumbai'
    },
    {
      id: '27',
      name: 'Delhi'
    },
    {
      id: '33',
      name: 'Pune'
    },
    {
      id: '25',
      name: 'Chennai'
    },
    {
      id: '28',
      name: 'Hyderabad'
    },
    {
      id: '30',
      name: 'Kolkata'
    },
    {
      id: '22',
      name: 'Ahmedabad'
    }
  ]
};

export const SOCIETY_AMENITIES = [
  {
    value: 'Clubhouse',
    key: 'Club House'
  },
  {
    value: 'Security',
    key: 'Security'
  },
  {
    value: '24Hr Backup',
    key: '24Hr Backup'
  },
  {
    value: 'Rainwater Harvesting',
    key: 'Rain Water Harvesting'
  },
  {
    value: 'Maintenance',
    key: 'Maintenance Staff'
  },
  {
    value: 'Intercom',
    key: 'Intercom'
  },
  {
    value: 'Garden',
    key: 'Garden'
  },
  {
    value: 'Community Hall',
    key: 'Community Hall'
  },
  {
    value: 'Electricity Full',
    key: 'Electricity Full'
  },
  {
    value: 'Electricity Partial',
    key: 'Electricity Partial'
  },
  {
    value: 'Badminton',
    key: 'Badminton Court'
  },
  {
    value: 'Basketball',
    key: 'Basket Ball Court'
  },
  {
    value: 'Play Area',
    key: 'Play Area'
  },
  {
    value: 'Swimming Pool',
    key: 'Swimming Pool'
  },
  {
    value: 'Tennis',
    key: 'Tennis Court'
  },
  {
    value: 'Gym',
    key: 'Gymnasium'
  },
  {
    value: 'Indoor Games',
    key: 'Indoor Games'
  },
  {
    value: 'Bank/Atm',
    key: 'Bank/Atm'
  },
  {
    value: 'Cafeteria',
    key: 'Cafeteria'
  },
  {
    value: 'Library',
    key: 'Library'
  },
  {
    value: 'Health Facilities',
    key: 'Health Facilities'
  },
  {
    value: 'Recreation Facilities',
    key: 'Recreation Facilities'
  },
  {
    value: 'Wifi',
    key: 'Wifi'
  },
  {
    value: 'Broadband Internet',
    key: 'Broadband Internet'
  },
  {
    value: 'Temple',
    key: 'Temple'
  }
];

export const TOKEN_VALUE_MAP = {
  $bhk: 'no_of_rooms',
  $sqft: 'carpet_area',
  $plotSqft: 'plot_area',
  $propertyType: 'property_type',
  $locality: 'locality',
  $posession: 'available_from',
  $bathrooms: 'bathroom',
  $balconies: 'no_of_balcony',
  $onFloor: 'property_on_floor',
  $totalFloor: 'total_floors',
  $salePrice: 'price',
  $rentPrice: 'price',
  $parking: 'parking',
  $furnishing: 'furnished',
  $availableFrom: 'available_from',
  $negotiable: 'is_negotiable',
  $projectName: 'project',
  $intent: 'intent',
  $category: 'category',
  $city: 'city_name'
};

export const TEMPLATES = {};

TEMPLATES.CF = [
  {
    intent: 'SELL',
    propertyType: 'APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Well designed $bhk $propertyType, $sqft carpet area, is available in $locality. Its in $projectName. Possession is $posession. There are $bathrooms and $balconies.The property is on $onFloor. Sale price is $salePrice and is $negotiable. $parking.'
  },
  {
    intent: 'RENT',
    propertyType: 'APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Well designed $bhk $propertyType, $sqft carpet area, is available in $locality. Its in $projectName. It is $furnishing. There are $bathrooms and $balconies.The property is on $onFloor. Rent is $rentPrice and $negotiable. $parking. It is available for rent from $availableFrom.'
  },
  {
    intent: 'SELL',
    propertyType: 'BUILDER_FLOOR',
    content:
      // eslint-disable-next-line max-len
      'Well designed $bhk $propertyType, $sqft carpet area, is available in $locality. Its in $projectName. Possession is $posession. There are $bathrooms and $balconies.The property is on $onFloor. Sale price is $salePrice and is $negotiable. $parking.'
  },
  {
    intent: 'RENT',
    propertyType: 'BUILDER_FLOOR',
    content:
      // eslint-disable-next-line max-len
      'Well designed $bhk $propertyType, $sqft carpet area, is available in $locality. Its in $projectName. It is $furnishing. There are $bathrooms and $balconies.The property is on $onFloor. Rent is $rentPrice and $negotiable. $parking. It is available for rent from $availableFrom.'
  },
  {
    intent: 'SELL',
    propertyType: 'PLOT',
    content:
      // eslint-disable-next-line max-len
      'Residential plot available for sale. Plot area $plotSqft. Located in $locality. $projectName. Available for $salePrice, $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'HOUSE_VILLA',
    content:
      // eslint-disable-next-line max-len
      'This $bhk, $sqft, $propertyType is located in $locality. $projectName. Possession is $posession. It is a well designed property with $bathrooms and  $balconies. It is on $onFloor of a $totalFloor building. The  $propertyType is available for $salePrice, $negotiable. $parking.'
  },
  {
    intent: 'RENT',
    propertyType: 'HOUSE_VILLA',
    content:
      // eslint-disable-next-line max-len
      'This $bhk, $sqft $propertyType is located in $locality. $projectName. It is a $furnishing property with $bathrooms and $balconies. It is on $onFloor of the building. Rent is $rentPrice, $negotiable. $parking. It is available for rent $availableFrom.'
  },
  {
    type: 'default',
    content: 'This $propertyType is located in $locality. $projectName.'
  }
];

TEMPLATES.QH = [
  {
    intent: 'SELL',
    propertyType: 'APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Well maintained, beautiful $bhk $category $propertyType for sale is available. With amenities like $bathrooms, $balconies, $parking in $locality with $sqft carpet area. This flat is on $onFloor of total $onFloor with $bathrooms, $balconies and $parking. Sale price is $salePrice and is $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'HOUSE_VILLA',
    content:
      // eslint-disable-next-line max-len
      'Grab well designed $bhk $category independent $propertyType of $sqft carpet area for sale in $locality. Its in $projectName. There are $bathrooms and $balconies. $parking. Sale price is $salePrice and is $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'BUILDER_FLOOR',
    content:
      // eslint-disable-next-line max-len
      'Properly designed $bhk $category $propertyType of $sqft carpet area for sale in $locality. by $projectName. It is on $onFloor with amenities like $bathrooms, $balconies, $parking. Possession is $posession. Sale price is $salePrice and is $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'PLOT',
    content:
      // eslint-disable-next-line max-len
      '$category $propertyType available for sale with area of $plotSqft. Located in $locality. $projectName. Available for $salePrice, $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'STUDIO_APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Beautiful & well made $bhk $category $propertyType of $sqft carpet area for sale in $locality. by $projectName. It is on $onFloor with amenities like $bathrooms, $balconies, $parking. Possession is $posession. Sale price is $salePrice and is $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'FARM_HOUSE',
    content:
      // eslint-disable-next-line max-len
      'Nicely designed $bhk $category $propertyType of $sqft carpet area for sale in $locality. by $projectName. With amenities like $bathrooms, $balconies, $parking. Possession is $posession. Sale price is $salePrice and is $negotiable.'
  },

  {
    intent: 'SELL',
    propertyType: 'OFFICE',
    content:
      // eslint-disable-next-line max-len
      'A freehold, $furnishing $category $propertyType with $sqft carpet area. Is available for sale at $locality. The property has $totalFloor with amenities like $bathrooms, $balconies, $parking. Possession is $posession. Sale price is $salePrice and is $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'SHOP',
    content:
      // eslint-disable-next-line max-len
      'A freehold, $furnishing $category $propertyType with $sqft carpet area. Is available for sale at $locality. The property has $totalFloor with amenities like $bathrooms, $balconies, $parking. Possession is $posession. Sale price is $salePrice and is $negotiable.'
  },
  {
    intent: 'SELL',
    propertyType: 'COMPLEX',
    content:
      // eslint-disable-next-line max-len
      'A freehold, $furnishing $category $propertyType with $sqft carpet area. Is available for sale at $locality. The property has $totalFloor with amenities like $bathrooms, $balconies, $parking. Possession is $posession. Sale price is $salePrice and is $negotiable.'
  },

  {
    intent: 'SELL',
    propertyType: 'LAND',
    content:
      // eslint-disable-next-line max-len
      '$category $propertyType available for sale with area of $plotSqft. Located in $locality. $projectName. Available for $salePrice, $negotiable.'
  },

  {
    intent: 'RENT',
    propertyType: 'APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Well maintained, beautiful $bhk $category $propertyType for rent is available with amenities like $bathrooms, $balconies, $parking in $locality with $sqft carpet area. This flat is on $onFloor of total $onFloor with $bathrooms, $balconies, $parking. Rent is $rentPrice which is $negotiable and available for rent from $availableFrom.'
  },
  {
    intent: 'RENT',
    propertyType: 'HOUSE_VILLA',
    content:
      // eslint-disable-next-line max-len
      'Grab well designed $bhk $category Independent $propertyType of $sqft carpet area for rent in $locality by $projectName. It is on $onFloor with amenities like $bathrooms, $balconies, $parking. Rent is $rentPrice which is $negotiable and available for rent from $availableFrom.'
  },
  {
    intent: 'RENT',
    propertyType: 'BUILDER_FLOOR',
    content:
      // eslint-disable-next-line max-len
      'Properly designed $bhk $category $propertyType of $sqft carpet area for rent in $locality by $projectName.It is on $onFloor with Amenities like $bathrooms, $balconies, $parking. It is available for rent from $availableFrom.'
  },
  {
    intent: 'RENT',
    propertyType: 'STUDIO_APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Beautiful & well made $bhk $category $propertyType of $sqft carpet area for rent in $locality by $projectName.It is on $onFloor with amenities like $bathrooms, $balconies, $parking. It is available for rent from $availableFrom.'
  },
  {
    intent: 'RENT',
    propertyType: 'FARM_HOUSE',
    content:
      // eslint-disable-next-line max-len
      'Nicely designed $bhk $category $propertyType of $sqft carpet area for rent in $locality by $projectName.It is on $onFloor with amenities like $bathrooms, $balconies, $parking. It is available for rent from $availableFrom.'
  },
  {
    intent: 'RENT',
    propertyType: 'SERVICE_APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Nicely designed $bhk $category $propertyType of $sqft carpet area for rent in $locality by $projectName.It is on $onFloor with amenities like $bathrooms, $balconies, $parking. It is available for rent from $availableFrom.'
  },

  {
    intent: 'RENT',
    propertyType: 'OFFICE',
    content:
      // eslint-disable-next-line max-len
      'A freehold, $furnishing $category $propertyType with $sqft carpet area. Is available for rent at $locality. The property has $totalFloor with amenities like $bathrooms, $balconies, $parking. It is available for rent from $availableFrom.'
  },
  {
    intent: 'RENT',
    propertyType: 'SHOP',
    content:
      // eslint-disable-next-line max-len
      'A freehold, $furnishing $category $propertyType with $sqft carpet area. Is available for rent at $locality. The property has $totalFloor with amenities like $bathrooms, $balconies, $parking. It is available for rent from $availableFrom.'
  },
  {
    intent: 'RENT',
    propertyType: 'COMPLEX',
    content:
      // eslint-disable-next-line max-len
      'A freehold, $furnishing $category $propertyType with $sqft carpet area. Is available for rent at $locality. The property has $totalFloor with amenities like $bathrooms, $balconies, $parking. It is available for rent from $availableFrom.'
  },

  {
    intent: 'PG',
    propertyType: 'APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Spacious $category Paying Guests $propertyType is available near your workspace. Private/Shared Sanitised Rooms with security of $amount. Amenities like $bathrooms, $balconies, $parking.'
  },
  {
    intent: 'PG',
    propertyType: 'HOUSE_VILLA',
    content:
      // eslint-disable-next-line max-len
      'Modern $category Paying Guests $propertyType is available near your workspace. Private/Shared Sanitised Rooms with security of $amount. Amenities like $bathrooms, $balconies, $parking.'
  },
  {
    intent: 'PG',
    propertyType: 'BUILDER_FLOOR',
    content:
      // eslint-disable-next-line max-len
      'Affordable $category Paying Guests $propertyType is available near your workspace. Private/Shared Sanitised Rooms with security of $amount. Amenities like $bathrooms, $balconies, $parking.'
  },

  {
    intent: 'FLATMATE',
    propertyType: 'APARTMENT',
    content:
      // eslint-disable-next-line max-len
      'Your search for $category $propertyType ends here, this home is conveniently located & comes at just with $rentPrice. Amenities such as $bathrooms, $balconies, $parking this home offers you a lot of convenience. For more information contact QuikrHomes.'
  },
  {
    intent: 'FLATMATE',
    propertyType: 'HOUSE_VILLA',
    content:
      // eslint-disable-next-line max-len
      'Your search for $category $propertyType ends here, this home is conveniently located & comes at just with $rentPrice. Amenities such as $bathrooms, $balconies, $parking this home offers you a lot of convenience. For more information contact QuikrHomes.'
  },
  {
    intent: 'FLATMATE',
    propertyType: 'BUILDER_FLOOR',
    content:
      // eslint-disable-next-line max-len
      'Your search for $category $propertyType ends here, this home is conveniently located & comes at just with $rentPrice. Amenities such as $bathrooms, $balconies, $parking this home offers you a lot of convenience. For more information contact QuikrHomes.'
  },
  {
    type: 'default',
    content: '$category $propertyType for $intent in $locality, $city.'
  }
];
